<ul nz-menu nzMode="horizontal">
  <li nz-submenu nzPlacement="bottomCenter" [nzTitle]="'header.links.mainPage' | translate" [routerLink]="dashboardRoute">
  </li>
  <li nz-submenu nzPlacement="bottomCenter" [nzTitle]="'header.links.myInvestments' | translate" [routerLink]="investmentsRoute">
  </li>
 <li nz-submenu nzPlacement="bottomCenter" [nzTitle]="productsTitle" nzMenuClassName="products-links-submenu"
      [nzOpen]="productsLinkActive() && !popupExplicitlyHidden()" class="products-link"
      [ngClass]="{'products-link-active': productsLinkActive()}">
    <div
      class="products-panel"
      (mouseenter)="productsPopupStart()"
      (mouseleave)="productsPopupEnd()"
    >
      @for (tile of productsSubmenuTiles; track tile) {
        <liberro-header-submenu-tile
          [icon]="tile.icon"
          [productsKey]="tile.productsKey"
          [route]="tile.route"
          [fragment]="tile.fragment"
          (actionBtnClicked)="hidePopup()"
        ></liberro-header-submenu-tile>
      }
    </div>
  </li>
  <li nz-submenu nzPlacement="bottomCenter" [nzTitle]="'header.links.posts' | translate" [routerLink]="blogRoute">
  </li>
<!--  <li nz-submenu nzPlacement="bottomCenter" [nzTitle]="'header.links.aboutUs' | translate">-->
<!--  </li>-->

  <li nz-submenu nzPlacement="bottomCenter" [routerLink]="collaboratorRoute" [nzTitle]="'header.links.myConsultant' | translate">
  </li>
</ul>

<ng-template #productsTitle>
  <span
      (mouseenter)="productsLinkHoverStart()"
      (mouseleave)="productsLinkHoverEnd()"
  >
  <span class="ant-menu-title-content">{{ 'header.links.products' | translate }}</span>
  <svg-icon
    class="products-chevron"
    [src]="productsLinkActive() ? 'assets/icons/chevron-up.svg' : 'assets/icons/chevron-down.svg'"
  ></svg-icon>
</span>
</ng-template>
